module.exports = __webpack_public_path__ + "static/media/Dribbble_IMG.2c2e845b.png";